import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ApplicationPage from "./pages/ApplicationPage";
import LegalPage from "./pages/LegalPage";
import Dashboard from "./pages/Dashboard";
import WebinarBookingPage from "./pages/WebinarBookingPage";
import VideoPage from "./pages/VideoPage";
import BookingCalendarPage from "./pages/BookingCalendarPage";
import ThankYouPage from "./pages/ThankYouPage";
import ApplyV2Page from "./pages/ApplyV2Page";
import VslV2Page from "./pages/VslV2Page";
import { initPixels } from "./pixels";
import { initTimeTracking, captureAttribution, initAutoTrack } from "./analytics";

function App() {
  useEffect(() => {
    initPixels();
    captureAttribution();
    initTimeTracking();
    initAutoTrack();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ApplicationPage />} />
          <Route path="/application" element={<ApplicationPage />} />
          <Route path="/webinar-booking" element={<WebinarBookingPage />} />
          <Route path="/video" element={<VideoPage />} />
          <Route path="/booking-calendar" element={<BookingCalendarPage />} />
          <Route path="/calendar-booking" element={<BookingCalendarPage />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="/apply-v2" element={<ApplyV2Page />} />
          <Route path="/vsl-v2" element={<VslV2Page />} />
          <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
          <Route path="/terms" element={<LegalPage slug="terms" />} />
          <Route path="/disclaimer" element={<LegalPage slug="disclaimer" />} />
          <Route path="/nzfsqnqqyljkvs-8f3a2c" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
